import moment, { Moment } from 'moment'
import { ITimeSlot } from '../../../../app/entities/TimeSlot'
import { IRouteInstruction } from '../../../../app/entities/RouteInstruction'

const ONE_AND_A_HALF_HOURS = 1.5 // hours
const THREE_HOURS_FOR_DELIVERY_WINDOW = 3 // hours

// This function is replicated in app/eworkflows/order/time-slot/determine-halved-time-slot.ts
export default function determineHalvedTimeSlot(
  timeSlot?: ITimeSlot,
  routeInstruction?: IRouteInstruction,
  isDelivery?: boolean,
): {
  fromTimeMoment: Moment | undefined
  toTimeMoment: Moment | undefined
} {
  let arrivalTimeWindow: any = {
    fromTimeMoment: undefined,
    toTimeMoment: undefined,
  }
  if (!timeSlot || !routeInstruction) {
    return arrivalTimeWindow
  }

  // For deliveries, use startTime and startTime + 3 hours
  if (isDelivery) {
    const { startTime } = routeInstruction
    return {
      fromTimeMoment: moment.utc(startTime),
      toTimeMoment: moment
        .utc(startTime)
        .add(THREE_HOURS_FOR_DELIVERY_WINDOW, 'hours'),
    }
  }

  // For installations, use 1.5 hour window logic
  const { fromTime, toTime } = timeSlot
  const { startTime } = routeInstruction

  const fromTimeMinusStartTime = moment.utc(startTime).diff(fromTime)
  const startTimeMinusToTime = moment.utc(toTime).diff(startTime)

  if (fromTimeMinusStartTime < startTimeMinusToTime) {
    arrivalTimeWindow = {
      fromTimeMoment: moment.utc(fromTime),
      toTimeMoment: moment.utc(fromTime).add(ONE_AND_A_HALF_HOURS, 'hours'),
    }
  } else {
    arrivalTimeWindow = {
      fromTimeMoment: moment
        .utc(toTime)
        .subtract(ONE_AND_A_HALF_HOURS, 'hours'),
      toTimeMoment: moment.utc(toTime),
    }
  }

  return arrivalTimeWindow
}
